<template>

</template>

<script>
    import Notification from "../helpers/Notification";
    import FormErrors from "./FormErrors";

    export default {
        name: 'Form',
        mixins: [FormErrors],
        data() {
            return {
                success: false,
                error: false
            };
        },
        methods: {
            post(url, data) {
                this.success = false;
                this.error = false;
                axios.post(url, data)
                    .then((res) => {
                            this.onSuccess(res.data.message);
                        }
                    )
                    .catch((error) => {
                            if(error && error.response.status == 422) {
                                this.setErrors(error.response.data.errors);
                            }else {
                                this.onFailure(error.response.data.message);
                            }
                        }
                    );
            },
            put (url, data) {
                this.success = false;
                this.error = false;
                axios.put(url, data)
                    .then(res => {
                        this.onSuccess(res.data.message);
                    })
                    .catch((error) => {
                        if(error && error.response.status == 422) {
                            this.setErrors(error.response.data.errors);
                        }else {
                            this.onFailure(error.response.data.message);
                        }
                    }
                );
            },
            delete (url) {
                this.success = false;
                this.error = false;
                Notification.methods.confirm(this.$t('Confirmation') , this.$t('Are you sure you want to delete this?')).then(res => {
                    axios.delete(url)
                        .then(res => {
                            this.onSuccess(res.data.message);
                        })
                        .catch((error) => {
                            if(error && error.response.status == 422) {
                                this.setErrors(error.response.data.errors);
                            }else {
                                this.onFailure(error.response.data.message);
                            }
                        }
                    );
                });
            },
            onSuccess(message) {
                Notification.methods.success(message);
                this.reset();
                this.success = true;
                this.showModal = false;
            },
            onFailure( message ){
                Notification.methods.warning('Server error');
                console.log(message);
                this.error = true;
            },
            reset() {
                this.clearAllErrors();
                for(let field in this.form) {
                    this.form[field] = null;
                }
            }
        }
    }
</script>
